import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { UserStore } from "@dcc/vestas-online/data-access";
import { filter, map, take } from "rxjs";
import { USER_SETTINGS_COMPLETED_KEY } from "@dcc/vestas-online/user/onboarding/domain";

export function onBoardUser(): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const userStore = inject(UserStore);
        const router = inject(Router);

        return userStore.user$.pipe(
            filter((user) => !!user),
            take(1),
            map((user) => {
                const userSettingsCompleted = user.userPreferences[USER_SETTINGS_COMPLETED_KEY];

                if (!userSettingsCompleted) {
                    const _url = state.url.includes("user-setup") ? "jumpboard" : state.url;
                    return router.createUrlTree(["app", "user-setup"], { queryParams: { callback: _url } });
                } else {
                    return true;
                }
            })
        );
    };
}
